module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-Hant":{"registrationOverview":"報名概覽","allForms":"所有報名表單"},"en":{"registrationOverview":" Overview","allForms":"All Forms"}}')
  delete Component.options._Ctor
}
